module.exports = __webpack_public_path__ + "83ded3e0.svg";